<template>
    <b-overlay :show="loading && loading_id === $options.name" rounded="sm" :opacity="opacity">
        <b-alert show dismissible :variant="color" v-if="(user.user_function == 1 && boletoDisponivel && $route.name != 'subscription')">Olá {{parceiro.name}},
            {{ aviso }}
            <b-button variant="dark" @click.prevent="$router.push('subscription')">Visualizar cobrança</b-button></b-alert>
        <router-view></router-view>
        <template #overlay>
            <div class="text-center">
                <loading />
            </div>
        </template>
    </b-overlay>
</template>
<script>

import { mapState, mapMutations } from "vuex";
export default {
    name: "viewRota",
    data() {
        return {
            opacity: 0.4,

            aviso: '',
            color: 'primary',
        };
    },
    watch: {
        $options(to, from) {
            this.setLoadId(to.name);
        },
        $route() {
            if (
                this.parceiro.user_id &&
                (!this.parceiro.plano || !this.parceiro.plano.status)
            )
                this.onClick();
        }
    },
    computed: {
        ...mapState("loading", ["loading", "loading_id"]),
        ...mapState("user", ["parceiro", "user"]),

        boletoDisponivel() {

            if (this.parceiro.subscription && this.parceiro.subscription.payment == 'banking_billet' && this.parceiro.subscription.charges) {

                let charges = this.parceiro.subscription.charges.filter((charge) =>charge.status != 'identified' && charge.status != 'paid' && charge.status != 'settled')


                if (charges.length > 0) {
                    let payment = JSON.parse(charges.pop().payment);

                    console.log(payment);

                    let current_month_billet = this.moment(payment.banking_billet.expire_at).locale('pt-BR').format('MMMM');



                    if (this.moment().isSame(payment.banking_billet.expire_at,'day') &&  this.moment().isSame(payment.banking_billet.expire_at,'month') &&this.moment().isSame(payment.banking_billet.expire_at,'year')) {
                        this.aviso = 'seu boleto do mês de '+ current_month_billet + ' vence hoje. Evite multas e o bloqueio do acesso em 5 dias após o vencimento, caso o pagamento tenha sido realizado, o mesmo será confirmado em até 48 horas.';
                        this.color = 'warning';
                    } else if (this.moment() > this.moment(payment.banking_billet.expire_at)) {
                        this.current_month_billet = "";
                        this.aviso = 'consta em nossos registros pendência no pagamento da sua assinatura. Evite o bloqueio do acesso em 5 dias após o vencimento, caso o pagamento tenha sido efetuado, o mesmo será confirmado em até 48 horas.';
                        this.color = 'danger';
                    }else{
                        this.aviso = 'seu boleto do mês de ' + current_month_billet + ' já está disponível!';
                    }

                    if (this.moment() >= this.moment(payment.banking_billet.expire_at).add(-8, 'days'))
                        return true;
                }




            }

            return false;

        }
    },
    created() {
        this.setLoadId(this.$options.name);
    },
    methods: {
        ...mapMutations("loading", ["setLoadId"]),
        onClick() {
            $("#btnPlanos").click();
        }
    }
};
</script>
